import { createContext } from "react";

export const FeatureToggleContext = createContext({
  // If we don't case this array to an array of strings, we will end up with
  // an array of never or any.
  disabledFeatures: [] as string[],
});
